import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_components");

Vue.use(Router);

const routes = [{
        path: "/",
        component: _import("www/main"),
        children: [{
            path: "/",
            name: "index",
            component: _import("www/index"),
        }],
    },

    {
        path: "/mgtv",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv",
                name: "mgtv",
                component: _import("mgtv/index"),
            },
        ],
    },
    {
        path: "/mgtv_semi",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv_semi",
                name: "mgtv_semi",
                component: _import("mgtv/index"),
            },
        ],
    },
    {
        path: "/mgtv_final",
        component: _import("mgtv/main"),
        children: [{
                path: "/mgtv_final",
                name: "mgtv_final",
                component: _import("mgtv/index"),
            },
        ],
    },

    {
        path: "/vn",
        component: _import("vn/index"),
    },
];


function addCRouter(channel, dir){
    if(dir == undefined) dir = channel;

    routes.push({
        path: `/${channel}`,
        component: _import(`${dir}/index`),
        children: [{
                path: "/",
                name: channel + "#index",
                component: _import(`${dir}/compete-Pre`),
            },
            {
                path: `/${channel}/login`,
                name: channel + "#login",
                component: _import(`${dir}/login`),
            },
            {
                path: `/${channel}/signup`,
                name: channel + "#signup",
                component: _import(`${dir}/signup`),
            },
            {
                path: `/${channel}/userIndex`,
                name: channel + "#userIndex",
                component: _import(`${dir}/userIndex`),
            },
            {
                path: `/${channel}/rank`,
                component: _import(`${dir}/rank`),
            },
            {
                path: `/${channel}/userGroups`,
                component: _import(`${dir}/user-groups`),
            },
        ],
    })
}


// 全国
addCRouter("teacher"); // 教师培训及考核

// 第八届ICode国际青少年编程活动
addCRouter("2026", "2026");

// WRC相关活动
routes.push({
    path: "/wrc",
    component: _import("wrc/index"),
    children: [{
        name: "wrc_list",
        path: "/",
        component: _import("wrc/compete-Pre"),
    }],
})

routes.push({
    path: "/wrc_:channel",
    name: "wrc_main",
    component: _import("wrc/template/main"),
    children: [{
            name: "wrc_index",
            path: "/wrc_:channel/",
            component: _import("wrc/template/index"),
        },
        {
            name: "wrc_login",
            path: "/wrc_:channel/login",
            component: _import("wrc/template/login"),
        },
        {
            name: "wrc_signup",
            path: `/wrc_:channel/signup`,
            component: _import("wrc/template/signup"),
        },
        {
            name: "wrc_userIndex",
            path: `/wrc_:channel/userIndex`,
            component: _import("wrc/template/userIndex"),
        },

    ],
})

function addRouter2026(dir){
    routes.push({
        path: `/${dir}:channel`,
        name: "${dir}_main",
        component: _import(`${dir}/main`),
        children: [{
                name: "${dir}_index",
                path: `/${dir}:channel/`,
                component: _import(`${dir}/index`),
            },
            {
                name: "${dir}_login",
                path: `/${dir}:channel/login`,
                component: _import(`${dir}/login`),
            },
            {
                name: "${dir}_signup",
                path: `/${dir}:channel/signup`,
                component: _import(`${dir}/signup`),
            },
            {
                name: "${dir}_userIndex",
                path: `/${dir}:channel/userIndex`,
                component: _import(`${dir}/userIndex`),
            },

        ],
    })
}

addRouter2026("israel2026");

routes.push({
    path: "/:channel",
    name: "contest_main",
    component: _import("template/main"),
    children: [{
            name: "contest_index",
            path: "/:channel/",
            component: _import("template/index"),
        },
        {
            name: "contest_login",
            path: "/:channel/login",
            component: _import("template/login"),
        },
        {
            name: "contest_signup",
            path: `/:channel/signup`,
            component: _import("template/signup"),
        },
        {
            name: "contest_userIndex",
            path: `/:channel/userIndex`,
            component: _import("template/userIndex"),
        },

    ],
})

// 加到最后面；
routes.push(
    {
        path: "/404",
        name: "t404",
        component: () =>
            import ("../components/common/t404.vue"),
    },
)

routes.push(
    {
        path: "*",
        redirect: "/404",
    },
)


const router = new Router({
    //后端支持可开
    mode: "history",
    routes: routes,

    scrollBehavior: () => ({
        y: 0,
    }),
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js